export default __webpack_public_path__ + "static/media/crew-06.986f2b0b.svg";